export const settings = {
  title: '销售设置',
  subtitle: '按项目启用或关闭功能，保存后立即生效。',
  searchPlaceholder: '搜索设置',
  sidebarSection: '管理',
  sidebarNghiepVu: '业务',
  sidebarCuaHang: '门店',
  sidebarTichHop: '集成',
  sidebarCucBo: '本地',
  loadError: '无法加载销售设置。',
  noData: '此分组暂无设置项。',
  noSearchResult: '未找到匹配的设置。',
  readOnlyHint: '您仅有查看设置的权限。',
  configureDetail: '详细配置',
  configureShort: '配置',
  detailSectionTitle: '详细选项',
  detailModalTitles: {
    BAN_HANG_HET_TON_KHO: '无库存时允许交易',
    GIAO_DICH_HANG_NGUNG_KINH_DOANH: '允许交易已停售商品',
    TU_DONG_TAO_PHIEU_XUAT: '自动创建出库单',
    TU_DONG_TAO_PHIEU_NHAP: '自动创建入库单',
    KHONG_THAY_DOI_THOI_GIAN: '锁定交易时间',
    DAT_HANG: '订单配置',
  },
  helpMore: '查看说明',
  tabSummary: '已启用 {active}/{total}',
  statusOn: '已启用',
  statusOff: '已关闭',
  saving: '保存中...',
  savedSuccess: '设置已保存。',
  updateError: '更新失败。',
  saoChep: {
    button: '复制到其他项目',
    title: '复制交易设置',
    description: '当前项目的全部交易设置（包括自动结算欠款）将覆盖所选项目。',
    selectAll: '全选',
    clear: '取消选择',
    empty: '您不属于其他项目。',
    action: '复制 ({count})',
    needSelected: '请至少选择一个项目。',
    success: '已将设置复制到 {count} 个项目。',
    loadError: '无法加载项目列表。',
    saveError: '复制设置失败。',
  },
  tichHopVanChuyen: {
    title: 'API 连接',
    description:
      '配置 GHTK、Viettel Post、Shopee Express (SPX) 连接，用于创建运单并接收 webhook。启用后可在配送发票中选择该承运商。',
    configure: '配置',
    empty: '尚未配置 — 点击“配置”填写承运商 token。',
    connected: '已连接',
    inactive: '未启用',
    production: '正式环境',
    sandbox: '沙箱',
    checkConnection: '检测',
    edit: '编辑',
    webhook: 'Webhook',
    lastError: '最近错误',
    notConfigured: '未配置',
    turnOn: '启用 — 可在配送发票中选择该承运商',
    turnOff: '停用 — 在配送发票中隐藏该承运商',
    environment: '环境',
    token: 'Token',
    lastCheck: '最近检测',
    copyWebhook: '复制 webhook URL 以在承运商处注册',
    connectionInfo: '连接信息',
    pickupAddress: '默认取货地址',
  },
  tabs: {
    hangHoa: '商品',
    doiTac: '伙伴',
    giaoDich: '交易',
    giaoHang: '配送',
    thongBaoZalo: 'Zalo 通知',
    logo: 'Logo',
    mauIn: '打印模板',
    quyTacMa: '编码规则',
    diaChiLayHang: '取货地址',
    formatSo: '数字格式',
    caiDatBang: '表格设置',
    thongBao: '通知',
    phamViXemDon: '单据可见范围',
  },
  phamViXemDon: {
    title: '单据可见范围',
    description: '配置员工可查看其他员工的订单/发票，以及向其他员工开放指定客户的发票。',
    loadError: '无法加载单据可见范围。',
    loadOptsError: '无法加载员工/客户列表。',
    save: '保存',
    savedSuccess: '已保存单据可见范围。',
    saveError: '保存单据可见范围失败。',
    sameUserError: '授权人与被授权人必须不同。',
    pickUser: '选择员工',
    pickUsers: '选择可查看的员工',
    pickCustomers: '选择客户',
    nguoiBan: {
      title: '按销售员查看',
      hint: '选择员工 A，再选择 A 可查看其订单/发票的销售员。',
      viewer: '被配置的员工 (A)',
      targets: '可查看这些销售员的单据',
    },
    khachHang: {
      title: '按客户开放发票',
      hint: '员工 A 向员工 B 开放客户 1、2 的发票 — 未开放的客户 B 不可见。',
      nguoiChoPhep: '授权员工 (A)',
      viewer: '被授权员工 (B)',
      customers: '已开放客户',
    },
  },
  cauHinhFields: {
    choPhepDatHangHetTonKho: '允许无库存下单',
    banHangKhiDaDatHang: '商品已下单时允许销售、调拨',
    choPhepChuyenChiNhanh: '允许将订单转到其他分店',
    banHang: '销售',
    datHang: '订货',
    hoaDon: '发票',
    traHang: '退货',
    datHangNhap: '采购订货',
    nhapHang: '进货',
    traHangNhap: '采购退货',
    chuyenHang: '调拨',
    phieuNhanHang: '收货单',
    yeuCauSuaChua: '维修申请',
    yeuCauXuatHoaDon: '开票申请',
    nhapKho: '入库',
    xuatKho: '出库',
    phieuThu: '收款单',
    phieuChi: '付款单',
    kiemKe: '盘点',
    xuatHuy: '报损出库',
    soQuy: '现金账',
    kiemKho: '盘点',
    sanXuat: '生产',
  },
  thoiGianGiaoDich: {
    khongChoPhep: '不允许',
    choPhep: '允许',
    gioiHan: '限制',
    truoc: '之前',
    sau: '之后',
    ngay: '天',
  },
  logoChiNhanh: {
    title: '分店 Logo',
    description: '每个启用中的分店一个 Logo，用于打印发票和单据。',
    empty: '当前项目没有启用中的分店。',
    choose: '选择 Logo',
    paste: '粘贴 Logo',
    pasteHint: '可拖放图片、从剪贴板粘贴或使用 http(s) 链接。',
    dragDrop: '将图片拖放到此处',
    remove: '删除 Logo',
    emptySlot: '暂无 Logo — 选择或拖放图片',
    attachedSummary: '已为 {attached}/{total} 个分店设置 Logo',
    loadError: '无法加载分店 Logo。',
    saveError: '无法保存分店 Logo。',
    applyToAll: '应用到全部',
    applyToSelected: '应用到已选',
    setSameForAll: '全部使用同一 Logo',
    setSameMenuHint: '选择有 Logo 的源分店',
    selectBranch: '选择',
    selectedCount: '已选 {count}',
    selectAll: '全选',
    clearSelect: '清除选择',
    applyConfirmTitle: '确认应用 Logo',
    applyConfirmAction: '应用',
    applyConfirmAll: '将“{source}”的 Logo 应用到全部 {count} 个分店？',
    applyConfirmSelected: '将“{source}”的 Logo 应用到已选的 {count} 个分店？',
    applySuccess: '已更新 {count} 个分店的 Logo。',
    applyPartial: '已更新 {ok}/{total} 个分店，部分失败。',
    applyNeedSource: '需要一个已有 Logo 的分店作为来源。',
    applyNeedSelected: '请至少选择一个目标分店。',
    applying: '正在应用…',
  },
  quyTacMa: {
    title: '编码规则',
    description: '每种编码可自动生成或手工输入。按项目保存。',
    summary: '自动生成 {auto}/{total} 种编码',
    loadError: '无法加载编码规则。',
    saveError: '无法保存编码规则。',
    groups: {
      hangHoa: '商品',
      doiTac: '伙伴',
      giaoDich: '交易',
    },
    items: {
      hangHoa: '商品编码',
      khachHang: '客户编码',
      nhaCungCap: '供应商编码',
      hoaDon: '发票编码',
      datHang: '订单编码',
      traHang: '退货编码',
      phieuNhapKho: '入库单编码',
      phieuXuatKho: '出库单编码',
      chuyenHang: '调拨编码',
      kiemKe: '盘点编码',
      phieuThu: '收款单编码',
      phieuChi: '付款单编码',
      yeuCauSuaChua: '维修单编码',
      yeuCauXuatHoaDon: '开票申请编码',
    },
    itemDesc: {
      hangHoa: 'SP + 8 位数字（SP00000001）。留空自动生成，也可手工输入。',
      khachHang: 'KH + 7 位数字（KH0000001）。留空自动生成，也可手工输入。',
      nhaCungCap: '当前默认：NCC + 4 位数字（NCC0001）。',
      hoaDon: '普通销售 HD0000001。维修申请销售 HDSC0000001。',
      datHang: 'DH0000001。',
      traHang: '按发票 THHD0000001 / THHDSC0000001。快速退货 TH0000001。承运退回 CHHD0000001 / CHHDSC0000001。',
      phieuNhapKho: 'NK0000001。',
      phieuXuatKho: 'XK0000001。',
      chuyenHang: 'TF0000001。',
      kiemKe: 'KK0000001。',
      phieuThu: 'THU0000001。',
      phieuChi: 'CHI0000001。',
      yeuCauSuaChua: 'YCSC0000001。',
      yeuCauXuatHoaDon: 'YCXV0000001。',
    },
    cheDoTitle: '生成方式',
    cheDo: {
      tuSinh: '自动生成',
      nhapTay: '手工输入',
    },
    cheDoHint: {
      tuSinh: '留空时按下方规则自动生成编码。',
      nhapTay: '新建时必须由用户输入编码。',
    },
    ruleTitle: '自动生成规则',
    prefix: '前缀',
    prefixRequired: '选择自动生成时必须填写前缀。',
    padLength: '数字位数',
    includeNguon: '加入来源',
    includeNguonHint: '在前缀和序号之间插入来源码（BT、DH、HD…）。',
    nguonMau: '预览来源',
    includeYymm: '加入年月',
    includeYymmHint: '按创建日期插入 YYMM，例如 2609。',
    previewLabel: '示例编码',
    previewManual: '由用户手工输入',
    rowAuto: '自动 · {preview}',
    rowManual: '新建时手工输入',
    columns: {
      loai: '编码类型',
      cheDo: '生成方式',
    },
  },
  numberFormatHint:
    '保存在当前浏览器（localStorage）。用于界面显示与 Excel 单元格格式。导出 Excel 时单元格保留原始数值；千分位/小数点按本机区域设置；小数位数按已保存配置。',
  numberFormatDecimals: '小数位',
  numberFormatPreview: '预览',
  numberFormatReset: '恢复默认',
  numberFormatSaveSuccess: '已保存数字格式',
  numberFormatResetSuccess: '已恢复默认数字格式',
  numberFormatVnd: 'VND 金额',
  numberFormatVndHint: '固定四舍五入（默认 {default}）',
  numberFormatUsd: 'USD 金额',
  numberFormatUsdHint: '最多位数，去尾零（默认 {default}）',
  numberFormatRmb: 'RMB / CNY 金额',
  numberFormatRmbHint: '最多位数，去尾零（默认 {default}）',
  numberFormatWeight: '重量（kg）',
  numberFormatWeightHint: '最多位数，去尾零（默认 {default}）',
  numberFormatVolume: '体积（m³）',
  numberFormatVolumeHint: '最多位数，去尾零（默认 {default}）',
  numberFormatGeneral: '通用数字',
  numberFormatGeneralHint: '最多位数，去尾零（默认 {default}）',
  tablePrefsHint:
    '在各卡片上用选列按钮配置（与列表工具栏相同）。可导出/导入到其他电脑，或清除恢复默认。',
  tablePrefsStatusSaved: '已保存自定义',
  tablePrefsStatusDefault: '使用默认',
  tablePrefsProduct: '商品',
  tablePrefsKhachHang: '客户',
  tablePrefsNhaCungCap: '供应商',
  tablePrefsHoaDon: '发票',
  tablePrefsDatHang: '订单',
  tablePrefsTraHang: '退货',
  tablePrefsCongNoKh: '客户应收',
  tablePrefsCongNoDon: '按单应收',
  tablePrefsCongNoThanhToan: '应收收款',
  tablePrefsCongNoHoanTien: '应收退款',
  tablePrefsKiemKe: '盘点',
  tablePrefsTaiKhoanQuy: '资金账户',
  tablePrefsPhieuThu: '收款单',
  tablePrefsPhieuChi: '付款单',
  tablePrefsBangGiaHangHoa: '商品价目表',
  tablePrefsYeuCauXuatHoaDon: '开票申请',
  browserPrefsResetAll: '全部清除',
  browserPrefsReset: '恢复默认',
  browserPrefsPathLabel: '页面',
  browserPrefsStorageLabel: '键',
  browserPrefsResetOneSuccess: '已清除配置 — 将使用默认',
  browserPrefsResetAllSuccess: '已清除本机全部列配置',
  browserPrefsExport: '导出配置',
  browserPrefsImport: '导入配置',
  browserPrefsExportSuccess: '已导出 {count} 项配置',
  browserPrefsExportError: '导出配置失败',
  browserPrefsImportSuccess: '已导入 {count} 项配置',
  browserPrefsImportError: '文件无效或导入失败',
  browserPrefsClearOrphans: '清理 {count} 个旧键',
  browserPrefsClearOrphansSuccess: '已删除 {count} 个多余键',
  browserPrefsOpenScreen: '打开页面',
  browserPrefsOpenShort: '打开',
  browserPrefsConfigureOnList: '配置列',
  browserPrefsEditJson: 'JSON',
  browserPrefsResetShort: '默认',
  browserPrefsJsonTitle: '编辑 localStorage JSON',
  browserPrefsJsonSaveSuccess: '已保存 JSON',
  browserPrefsJsonInvalid: 'JSON 无效',
  tuDongChotCongNo: {
    title: '自动结清应收',
    description: '为全部在用客户结清应收。选择任务运行日，以及应收结到哪一天。',
    lapLai: '重复',
    thangChay: '运行月份',
    ngayChay: '运行日',
    ngayTrongThang: '月内日期',
    gio: '时',
    phut: '分',
    ngayChot: '结清截止日',
    thangChot: '结清月份',
    thangSo: '{n}月',
    ngaySo: '{n}日',
    lap: {
      hangThang: '每月',
      hangNam: '每年',
    },
    moc: {
      dauThang: '月初',
      cuoiThang: '月末',
      ngayCuThe: '指定日期',
    },
    mocChot: {
      cungNgayChay: '与运行日同一天',
      cuoiThangTruoc: '运行日的上月末',
      cuoiNamTruoc: '上一年年末（12月31日）',
      cuoiThangNamTruocChon: '上一年某月月末',
      cuoiThangNamTruoc: '上一年{n}月末',
    },
    cum: {
      cuoiThangNam: '{thang}月末',
      dauThangNam: '{thang}月初',
      ngayThang: '{thang}月{n}日',
      cuoiThangThang: '每月月末',
      dauThangThang: '每月月初',
      ngayMoiThang: '每月{n}日',
    },
    tomTat: '{lap}，{cum} {gio} 运行。结清到：{mocChot}。',
    lanToi: '下次：{chay} 运行，应收结到 {chot}。',
    ngayNgan: '如果该月没有这一天，则取当月最后一天。',
  },
}
